// modules
import React, { memo } from 'react';
import { View } from '@upstox/upstox-ui';
import * as DOMPurify from 'dompurify';
import parseHTML from 'html-react-parser';
// typings
import { Props } from './typings';
// constant
import { DOMPurifyConfig } from './const';
// styles
import * as css from './styles';

const SanitizeHTML: React.FC<Props> = ({ html }) => {
  const cleanHTML = DOMPurify.sanitize(html, DOMPurifyConfig) as string;
  const convertedHTML = parseHTML(cleanHTML);

  return (
    <View css={css.sanitizedHTML}>
      {convertedHTML}
    </View>
  );
};

export default memo(SanitizeHTML);
